/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { useEffect } from "react";
import { useSelector } from "react-redux";

import { buildUrl } from "common/util";
import { SHIFT_CLAIMS_STATUSES_API_URL } from "store/api/constants";
import {
    shiftClaimsSelector,
} from "store/slices/shiftClaimsPolling";
import { useLazyGetShiftClaimsStatusesQuery } from "store/api/shiftsApi";

export const POLLING_TIME = 2000;

export const useShiftClaimsPolling = () => {
    const shiftClaims = useSelector(shiftClaimsSelector);

    const [trigger] = useLazyGetShiftClaimsStatusesQuery({
        pollingInterval: shiftClaims?.length > 0 ? POLLING_TIME : 0,
    });

    useEffect(() => {
        const triggerShiftClaimsPolling = async () => {
            if (shiftClaims?.length > 0) {
                const shiftIds = shiftClaims.map(({ shiftId }) => shiftId);
                const url = buildUrl(SHIFT_CLAIMS_STATUSES_API_URL, { shiftIds });
                await trigger({ url });
            }
        };

        triggerShiftClaimsPolling();
    }, [trigger, shiftClaims]);
};
